import React, { useState } from 'react';
import { Plus, Edit2, Power } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Table } from '../components/ui/Table';
import { Modal } from '../components/ui/Modal';
import { Input } from '../components/ui/Input';
import { Badge } from '../components/ui/Badge';
import { Venue } from '../types';
export function VenuesPage() {
  const [venues, setVenues] = useState<Venue[]>([{
    id: '1',
    name: 'Main Training Center',
    address: 'Dhaka, Bangladesh',
    capacity: 50,
    type: 'Training Center',
    status: 'active'
  }, {
    id: '2',
    name: 'Regional Office - Chittagong',
    address: 'Chittagong, Bangladesh',
    capacity: 30,
    type: 'Office',
    status: 'active'
  }]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingVenue, setEditingVenue] = useState<Venue | null>(null);
  const [formData, setFormData] = useState({
    name: '',
    address: '',
    capacity: 0,
    type: ''
  });
  const handleAdd = () => {
    setEditingVenue(null);
    setFormData({
      name: '',
      address: '',
      capacity: 0,
      type: ''
    });
    setIsModalOpen(true);
  };
  const handleEdit = (venue: Venue) => {
    setEditingVenue(venue);
    setFormData({
      name: venue.name,
      address: venue.address,
      capacity: venue.capacity,
      type: venue.type
    });
    setIsModalOpen(true);
  };
  const handleSave = () => {
    if (editingVenue) {
      setVenues(venues.map(v => v.id === editingVenue.id ? {
        ...v,
        ...formData
      } : v));
    } else {
      const newVenue: Venue = {
        id: Date.now().toString(),
        ...formData,
        status: 'active'
      };
      setVenues([...venues, newVenue]);
    }
    setIsModalOpen(false);
  };
  const toggleStatus = (id: string) => {
    setVenues(venues.map(v => v.id === id ? {
      ...v,
      status: v.status === 'active' ? 'inactive' : 'active'
    } : v));
  };
  const columns = [{
    key: 'name',
    header: 'Venue Name'
  }, {
    key: 'address',
    header: 'Address'
  }, {
    key: 'capacity',
    header: 'Capacity'
  }, {
    key: 'type',
    header: 'Type'
  }, {
    key: 'status',
    header: 'Status',
    render: (value: string) => <Badge variant={value === 'active' ? 'success' : 'default'} data-id="element-446">
          {value === 'active' ? 'Active' : 'Inactive'}
        </Badge>
  }, {
    key: 'actions',
    header: 'Actions',
    render: (_: any, row: Venue) => <div className="flex gap-2" data-id="element-447">
          <button onClick={() => handleEdit(row)} className="p-1 text-blue-600 hover:text-blue-800" title="Edit" data-id="element-448">
            <Edit2 className="w-4 h-4" data-id="element-449" />
          </button>
          <button onClick={() => toggleStatus(row.id)} className="p-1 text-gray-600 hover:text-gray-800" title="Toggle Status" data-id="element-450">
            <Power className="w-4 h-4" data-id="element-451" />
          </button>
        </div>
  }];
  return <div className="space-y-6" data-id="element-452">
      <div className="flex justify-between items-center" data-id="element-453">
        <div data-id="element-454">
          <h3 className="text-lg font-semibold text-gray-900" data-id="element-455">
            Venue Management
          </h3>
          <p className="text-sm text-gray-600 mt-1" data-id="element-456">
            Manage training venues and locations
          </p>
        </div>
        <Button onClick={handleAdd} data-id="element-457">
          <Plus className="w-4 h-4 mr-2" data-id="element-458" />
          Add Venue
        </Button>
      </div>

      <Table columns={columns} data={venues} emptyMessage="No venues added yet" data-id="element-459" />

      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} title={editingVenue ? 'Edit Venue' : 'Add New Venue'} footer={<>
            <Button variant="secondary" onClick={() => setIsModalOpen(false)} data-id="element-461">
              Cancel
            </Button>
            <Button onClick={handleSave} data-id="element-462">
              {editingVenue ? 'Update' : 'Add'} Venue
            </Button>
          </>} data-id="element-460">
        <div className="space-y-4" data-id="element-463">
          <Input label="Venue Name" value={formData.name} onChange={e => setFormData({
          ...formData,
          name: e.target.value
        })} required data-id="element-464" />
          <Input label="Address" value={formData.address} onChange={e => setFormData({
          ...formData,
          address: e.target.value
        })} required data-id="element-465" />
          <Input label="Capacity" type="number" value={formData.capacity.toString()} onChange={e => setFormData({
          ...formData,
          capacity: parseInt(e.target.value) || 0
        })} required data-id="element-466" />
          <Input label="Type" value={formData.type} onChange={e => setFormData({
          ...formData,
          type: e.target.value
        })} placeholder="e.g., Training Center, Office, Conference Room" required data-id="element-467" />
        </div>
      </Modal>
    </div>;
}